import { useState, useLayoutEffect } from "react";

// Constants for all components
const HEIGHTEMSCALE = 1 * 1.75;
const WIDTHEMSCALE = 0.4 * 1.75;

var convertrowunittoem = (value) => {
    /* Convert Row Unit to EM */
    return applyscaling(value, true);
};

var convertcolunittoem = (value) => {
    /* Convert Col Unit to EM */
    return applyscaling(value, false);
};

var applyscaling = (value, height) => {
    /* apply scaling to value */
    var scaling;
    if (height) scaling = HEIGHTEMSCALE;
    else scaling = WIDTHEMSCALE;
    // round it to a single digit
    return (scaling * value).toFixed(1);
};

export { convertcolunittoem, convertrowunittoem };


export const useContainerDimensions = (myRef) => {
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)

    useLayoutEffect(() => {
        if (!myRef.current) return;

        const element = myRef.current;
        setWidth(element.offsetWidth);
        setHeight(element.offsetHeight);

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const cr = entry.contentRect;
                setWidth(cr.width);
                setHeight(cr.height);
            }
        });
        observer.observe(element);

        return () => observer.disconnect();
    }, [myRef])

    return { width, height }
}
const characterWidth = 7;
const tiny_chars = "iI!',.:;";
const thin_chars = "fjtJ1$&()*+-/[\]^{|}`";
const thick_chars = "mwCGHMOQW";

const getAdjustment = (text) => {
    return text.split("").reduce((acc, char) => {
        if (tiny_chars.includes(char)) { acc -= 0.6 };
        if (thin_chars.includes(char)) { acc -= 0.5 };
        if (thick_chars.includes(char)) { acc += 0.5 };
        return acc;
    }, 0);
}

const getLongestWord = (decodedString) => {
    const words = decodedString.split(/ |-/);
    return words.reduce((maxLength, word) => {
        return Math.max(maxLength, word.length + getAdjustment(word));
    }, 0);
};

export const calculateRequiredRows = (prompt, gridWidth) => {
    const promptWidthPercentage = parseFloat(prompt.width);
    const promptWidthPixels = (promptWidthPercentage / 100) * gridWidth;
    const charsPerRow = Math.max(10, Math.floor(promptWidthPixels / characterWidth));

    const decodedVal = decodeURIComponent(prompt.value);
    if (!decodedVal) {
        return 1;
    }

    const lines = decodedVal.split(/\r\n|\r|\n/);
    let requiredRows = 0;

    lines.forEach((line) => {
        if (!line.trim()) {
            requiredRows += 1; // Empty line still takes one row
            return;
        }
        
        // Simple and accurate calculation - just divide character count by chars per row
        const adjustedLength = line.length + getAdjustment(line);
        const rowsForThisLine = Math.ceil(adjustedLength / charsPerRow);
        
        requiredRows += Math.max(1, rowsForThisLine);
    });

    return Math.max(1, requiredRows);
}

export const oldcalculateRequiredRows = (prompt, gridWidth) => {
    const decodedVal = decodeURIComponent(prompt.value);
    const contentLength = decodedVal ? decodedVal.length : 0;
    const thin = decodedVal.split("").reduce((acc, char) => {
        if (thin_chars.split("").includes(char)) { acc += 1 };
        return acc;
    }, 0);
    const thick = decodedVal.split("").reduce((acc, char) => {
        if (thick_chars.split("").includes(char)) { acc += 1 };
        return acc;
    }, 0);
    const fieldlen = contentLength - (thin * 0.5) + (thick * 0.5) + 1;
    const longestWord = getLongestWord(decodedVal);
    const promptWidthPercentage = parseFloat(prompt.width);
    const promptWidthPixels = (promptWidthPercentage / 100) * gridWidth;
    const charsPerRow = promptWidthPixels / characterWidth;
    return Math.ceil(fieldlen / charsPerRow) + Math.floor(longestWord / charsPerRow) || 1;
}